<template>
  <div class="nav">
    <div class="sn-nav-back">
      <a class="sn-iconbtn" href="javascript:history.go(-1);">返回</a>
      <div class="title">{{tit}}</div>
    </div>
  </div>
</template>

<script>
    export default {
        name:"TopNav",
        props: {
            tit:{
            	type: String
            }
        }
    }
</script>

<style scoped>
    .nav{
        background: #ff9900;
    }
    .sn-nav-back{
      margin: 0;
        z-index: 999;
        border-bottom: 0;
        position: relative;
        height: 1.76rem;
        line-height: 1.76rem;
        font-size: 34px;
        width: 100%;
        a{
            height: 1.76rem;
        }
    }
    .sn-nav-back:before{
        border: solid #fff;
        border-width: 3px 0 0 3px;
        -webkit-transform: rotate(-45deg);
        left: .56rem;
    }
    .title{
        font-family:PingFangSC-Medium;
        text-align: center;
        color:#ffffff;
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/_topNav.vue